<template>
    <div class="columns is-multiline">
        <div v-if="filters.length" class="column is-full">
            <EditFilterComponent
            v-for="filter in filters"
            :key="filter.id"
            :filter="filter"
            :categories="categoryList"
            :subcategories="subcategoriesAll"
            :filtersDetail="filtersDetail"
            :filterOptionDetail="filterOptionDetail"
            :filterOptionListCreate="filterOptionListCreate"
            @filterListUpdate="fetchFilters"
            />
        </div>
        <div v-else class=" column is-full has-text-centered">
                <p class="title">Todavia no creaste ningun filtro</p>
                <p>Los filtros son una buena ayuda para que tus clientes encuentren lo que estan buscando de una forma mas rapida y amigable.</p>
            </div>
        <div class="column is-full has-text-centered">
            <b-button
            rounded
            type="is-primary"
            @click="createFilterModal=true">
                <b-icon icon="plus" class="m-r-5" size="is-small"></b-icon>
                Crear un filtro
            </b-button>
        </div>


        <b-modal :active.sync="createFilterModal" scroll="keep" :can-cancel='false'>
            <div class="modal-card" style="width: auto">
                
                <div class="modal-card-body has-text-centered">
                    <div class="columns is-multiline">
                        <div class="column is-full">
                            <p class="title is-size-3 has-text-centered">Agrega un nuevo filtro a tu tienda</p>
                        </div>
                        <div class="column is-half">
                            <b-field label="Nombre" label-position="on-border">
                                <b-input
                                v-model="newFilter.title"
                                >
                                </b-input>
                            </b-field>
                        </div>
                        <div class="column is-half">
                            <b-field 
                            label="Opciones" 
                            label-position="on-border" 
                            message="Presiona ENTER o agrega una coma para crear las diferentes opciones.">
                                <b-taginput
                                v-model="newFilter.optionsCreate">
                                </b-taginput>
                            </b-field>
                        </div>
                        <div class="column is-half">
                            <b-field 
                            label="Categoria" 
                            label-position="on-border" 
                            message="Elije una si quieres que este filtro sea exclusivo para una categoria">
                                <b-select expanded v-model="newFilter.category">
                                    <option v-for="x in categoryList" :key="x.id" :value="x.id">{{x.title}}</option>
                                </b-select>
                            </b-field>
                        </div>
                        <div class="column is-half">
                            <b-field 
                            label="Subcategoria" 
                            label-position="on-border"
                            message="Elije una si quieres que este filtro sea exclusivo para una subcategoria">
                                <b-select expanded v-model="newFilter.subcategory">
                                    <option v-for="x in subcategoryOptions" :key="x.id" :value="x.id">{{x.title}}</option>
                                </b-select>
                            </b-field>
                        </div>
                        
                        <div class="column is-full has-text-centered">
                             <b-button
                            type="is-grey"
                            rounded
                            @click="createFilterModal=false"
                            >
                                Cerrar
                            </b-button>
                            <b-button
                            type="is-primary"
                            rounded
                            class="m-l-5"
                            @click="createNewFilter"
                            >
                                <b-icon icon="save" size="is-small"></b-icon>
                                Guardar
                            </b-button>
                        </div>
                    </div>
                    
                </div>
            </div>
        </b-modal>
        <b-modal :active.sync="deleteFilterModal" scroll="keep" :can-cancel='false'>
            <div class="modal-card" style="width: auto">
                <div class="modal-card-body has-text-centered">
                    <p>Esta accion es irreversible</p>
                    <p>Seguro que quieres eliminar el filtro <b>"{{filterToDelete.title}}"</b> del sitio?</p>
                    <div class="columns m-t-20 ">
                        <div class="column is-full has-text-centered">
                            <b-button
                                type="is-grey"
                                rounded
                                @click="deleteFilterModal=false">
                                    Cancelar
                            </b-button>
                            <b-button
                                type="is-danger"
                                rounded
                                @click="deleteFilter">
                                    Eliminar
                            </b-button>
                        </div>
                    </div>
                </div>
            </div>
        </b-modal>
    </div>
    
</template>

<script>
import { getHandler, deleteHandler, debounce, patchHandler, postHandler } from '../../../../services/http'
import EditFilterComponent from './EditFilterComponent.vue'
export default {
    components:{
        EditFilterComponent
    },
    props:{
        filtersListCreate:{
            type:String,
            default:""
        },
        filtersDetail:{
            type:String,
            default:""
        },
        filterOptionDetail:{
            type:String,
            default:""
        },
        filterOptionListCreate:{
            type:String,
            default:""
        },
        categoryList:{
            type: Array,
            default: new Array([])
        },
        subcategoriesAll:{
            type: Array,
            default: new Array([])
        }
    },
    data(){
        return{
            loading:false,
            filters:[],
            addToSelectedFilterId:null,
            count:0,
            page:1,
            perPage:24,
            createFilterModal:false,
            newFilter:{},
            filterToDelete:{},
            deleteFilterModal:false
        }
    },
    computed:{
        subcategoryOptions(){
            var subs = this.subcategoriesAll.filter((element)=>{
                console.log(element)
                return element.category == this.newFilter.category
            })
            return subs
        }
    },
    methods:{
        async fetchFilters(){
            var url = this.filtersListCreate + `?page=${this.page}`
            this.loading = true
            var response = await getHandler(url, {error:false, success:false})
            this.loading = false
            this.count = response.count
            this.filters = response.results
        },

        async createNewFilter(){
            var error = {resource:'notify'}
            var success = {resource:'notify'}
            console.log(this.newFilter)
            var response = await postHandler(this.filtersListCreate, this.newFilter, {error, success})
            this.createFilterModal = false
            this.newFilter = {}
            this.fetchFilters()
        },

        onPageChange(page){
            this.page = page
            this.fetchFilters()
        },

    },
    created(){
        this.fetchFilters()
    }
}
</script>